import React from "react";

const Checkbox = props => {
  const onChange = e => {
    props.onChange({
      name: props.name,
      checked: e.target.checked,
      data: props.data
    });
  };

  const { name, id, checked } = props;
  return <input checked={checked} onChange={onChange} type="checkbox" name={name} id={id} />;
};

Checkbox.defaultProps = {
  checked: false
};

export default Checkbox;
